<ndt-add-existing-prompt-view
   [callState]="callState | async"
   [form]="form"
   [accountId]="accountId"
   [promptTypesToInclude]="promptTypesToInclude"
   (formCanceled)="onClose()"
   (formSubmitted)="onCreate()"
></ndt-add-existing-prompt-view>
